<script>
import { Line } from 'vue-chartjs'

import timeline from '../../../static/clients_per_day.json'
import monthData from '../../../static/clients_per_month.json'
export default {
  extends: Line,
  data () {
    return {
      timeline
    }
  },
  mounted () {
    console.log(timeline)
    let clients = []
    let date = []
    // let lastMonth = 0
    // let monthlyClients = []
    timeline.data.forEach(function (element) {
      clients.push(element.client)
      var tempDate = new Date(element.date)
      date.push((tempDate.getMonth() + 1) + '/' + tempDate.getDate() + '/' + tempDate.getFullYear())
      // lastMonth = tempDate.getMonth()
      // if (lastMonth === tempDate.getMonth()) {
      //   console.log('for month ' + tempDate.getMonth())
      //   console.log(element.client)
      //   monthlyClients.push({'month': tempDate.getMonth(), 'client': element.client})
      // }
    })
    let monthCount = []
    let months = []
    monthData.data.forEach(function (element) {
      monthCount.push(element.client)
      months.push(element.date)
      // var tempDate = new Date(element.date)
      // date.push((tempDate.getMonth() + 1) + '/' + tempDate.getDate() + '/' + tempDate.getFullYear())
      // lastMonth = tempDate.getMonth()
      // if (lastMonth === tempDate.getMonth()) {
      //   console.log('for month ' + tempDate.getMonth())
      //   console.log(element.client)
      //   monthlyClients.push({'month': tempDate.getMonth(), 'client': element.client})
      // }
    })

    // console.log(monthlyClients)
    // let count = 0
    // monthlyClients.filter((m) => {
    //   if (m.month === 11) {
    //     count += parseInt(m.client)
    //   }
    // })
    // console.log(count)
    this.renderChart({
      labels: months,
      datasets: [
        // {
        //   label: 'Days',
        //   backgroundColor: '#62b854',
        //   data: clients
        // },
        {
          label: 'Monthly Wifi Users',
          backgroundColor: '#63c2de',
          data: monthCount
        }
      ]
    }, {responsive: true, maintainAspectRatio: false})
  }
}
</script>



// WEBPACK FOOTER //
// src/views/charts/LineExample.vue